"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.2084 25L39.7084 12.5C39.907 12.3712 40.0737 12.199 40.1961 11.9964C40.3184 11.7937 40.393 11.5659 40.4144 11.3302C40.4358 11.0945 40.4034 10.857 40.3196 10.6356C40.2358 10.4142 40.1027 10.2148 39.9306 10.0524C39.7584 9.88996 39.5516 9.76877 39.3257 9.69798C39.0998 9.62718 38.8608 9.60862 38.6267 9.6437C38.3927 9.67878 38.1696 9.76659 37.9744 9.90049C37.7792 10.0344 37.617 10.2109 37.5 10.4167L25 22.9167L12.5 10.4167C12.3923 10.1911 12.232 9.99467 12.0327 9.84387C11.8333 9.69308 11.6007 9.59231 11.3543 9.55004C11.1079 9.50777 10.855 9.52523 10.6168 9.60095C10.3786 9.67666 10.162 9.80843 9.98523 9.98519C9.80848 10.1619 9.67671 10.3785 9.60099 10.6168C9.52528 10.855 9.50782 11.1079 9.55009 11.3543C9.59236 11.6006 9.69312 11.8333 9.84392 12.0326C9.99471 12.232 10.1911 12.3923 10.4167 12.5L22.9167 25L10.4167 37.5C10.1605 37.7865 10.0188 38.1573 10.0188 38.5417C10.0188 38.926 10.1605 39.2969 10.4167 39.5833C10.7032 39.8396 11.074 39.9812 11.4584 39.9812C11.8427 39.9812 12.2136 39.8396 12.5 39.5833L25 27.0833L37.5 39.5833C37.7865 39.8396 38.1574 39.9812 38.5417 39.9812C38.926 39.9812 39.2969 39.8396 39.5834 39.5833C39.8396 39.2969 39.9813 38.926 39.9813 38.5417C39.9813 38.1573 39.8396 37.7865 39.5834 37.5L27.2084 25Z",
    fill: fill
  }));
};

exports["default"] = _default;